export function safeBtoa(str: string): string {
  // prevent btoa with non-latin characters
  // btoa only works with characters in the Latin1 range

  // eslint-disable-next-line no-control-regex
  return btoa(str.replaceAll(/[^\u0000-\u007F]+/g, ''));
}
